import { Component, ErrorInfo, PropsWithChildren, ReactElement, createContext } from 'react';

export type ErrorBoundaryProps = {};

export type ErrorBoundaryHandlerContext = {
	renderError: (props: { error?: Error; info?: ErrorInfo }) => ReactElement;
};

const ErrorBoundaryHandler = createContext<ErrorBoundaryHandlerContext>({
	renderError: props => <div>Error: {props.error?.stack}</div>
});

/** This allows for customisation of the error boundary display for extension points */
export const ErrorBoundaryHandlerProvider = ({ children, ...props }: PropsWithChildren<ErrorBoundaryHandlerContext>) => (
	<ErrorBoundaryHandler.Provider value={props} children={children} />
);

export interface ErrorBoundaryState {
	hasError: boolean;
	error?: Error;
	info?: ErrorInfo;
}

export class ErrorBoundary extends Component<PropsWithChildren<ErrorBoundaryProps>, ErrorBoundaryState> {
	constructor(props: ErrorBoundaryProps) {
		super(props);
		this.state = {
			hasError: false
		};
	}

	componentDidCatch(error: Error, info: ErrorInfo) {
		// Display fallback UI
		this.setState({ hasError: true, error: error, info: info });
		// You can also log the error to an error reporting service
		//logErrorToMyService(error, info);
	}

	render() {
		const { hasError, error, info } = this.state;
		if (hasError) {
			// You can render any custom fallback UI
			//return <h1>Something went wrong.</h1>;
			return (
				<ErrorBoundaryHandler.Consumer>
					{({ renderError: Exception }) => <Exception error={error} info={info} />}
				</ErrorBoundaryHandler.Consumer>
			);
		}
		return this.props.children;
	}
}
